import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "gatsby";

const BorderButton = ({ label, link, primary, color }) => {
  const thisColor = color || 'green';
  const fill = primary ? `bg-${thisColor} white` : `${thisColor}`;

  if (link.indexOf('http') === 0 || link.indexOf('#') === 0) {
    // This is an external link, just use a regular A tag
    return (
      <a
        href={link}
        className={`f5 link dib dim ba ph3 pv2 mh3 mb2 db tc pointer b--${thisColor} ${fill}`}
      >
        {label}
      </a>
    );
  } else {
    // Internal link, use Link
    return (
      <Link
        to={link}
        className={`f5 link dib dim ba ph3 pv2 mh3 mb2 db tc pointer b--${thisColor} ${fill}`}
      >
        {label}
      </Link>
    );
  }
};

BorderButton.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  color: PropTypes.string,
};

export default BorderButton;
